module.exports = __webpack_public_path__ + "static/media/loginmark1.6bfc1e6a.png";